import { windowWidth } from "./utils";

const stickySidebar = {
  sidebar: document.querySelector<HTMLElement>('.product__sidebar'),
  stickyEle: document.querySelector<HTMLElement>('#jsStickyEle'),

  init() {
    if(windowWidth > 1200) {
    this.setStickyTop();
    this.bindEvents();
    }
  },

  bindEvents() {
    window.addEventListener('resize', () => {
      this.setStickyTop();
    });

    window.addEventListener('scroll', () => {
      this.setStickyTop();
    });
  },

  setStickyTop() {
    if (!this.sidebar || !this.stickyEle) return;

    const sidebarRect = this.sidebar.getBoundingClientRect();
    const stickyRect = this.stickyEle.getBoundingClientRect();

    const topValue = sidebarRect.top - stickyRect.top;

    this.sidebar.style.top = `${topValue + 75}px`;
  },
};

export default stickySidebar;